<template>
  <div class="home">
    <layVideo2 v-if="videodata.cover_url" :src="videodata.cover_url" :height="video_height" @playEndFun="videoplayEnd" :showfullscreen="showfullscreen" :poster="videodata.thumb"></layVideo2>

    <div class="video-jifen-title">
      <div class="video-jifen-title-title">{{videodata.movie_name}}</div>
      <div class="video-jifen-line"></div>
      <div class="playstatus" :class="{active:played}">{{played?"已学习":"未学习"}}</div>
    </div>

    <div class="back-list" @click="back()">返回列表</div>
  </div>

</template>
<style scoped>
  @import '../assets/css/listcomponentscss.css';
  .video-jifen-title{ display: flex; padding: 15px; align-items: center}
  .playstatus{ width: 60px; text-align: center; font-size: 16px; font-weight: bold; color: #999999}
  .playstatus.active{ color: #42b983}
  .video-jifen-title-title{ font-size: 14px; line-height: 20px; flex: 1; text-align: justify; word-break: break-all;
  }
  .video-jifen-line{ width: 1px; height: 16px; margin: 0 20px; background-color: #cccccc}
  .back-list{ position: absolute; left: 0; bottom:100px; background-color: #007aff; color: #fff; padding: 5px 10px}

</style>
<script>
// @ is an alias to /src
//http://play2.yitoutiao.net/13b1b1d07d3371edb9ef0764a3fc0102/47a93e22e4a7414183df20b696f8a182-2b8b850bf57cda90b30cab9210778c88-ld.mp4
//http://play2.yitoutiao.net/dfd8105084f071edb55c6732b68e0102/70d70ea273a34d2d9b4144865f170324-10cfe057af630ce65d9ea5e0309979e7-ld.mp4
import layVideo2 from '@/components/Video2.vue'
import config from '../config'
import utils from '../utils'
import { Toast } from 'vant';
import request from "../utils/request";
export default {
  name: 'Home',
  data(){
    return {
      video_height:200,
      played:false,
      src:"",
      showfullscreen:true,
      token:"",
      videodata:{
        cover_url:"",
        movie_name:"",
        thumb:""
      }
    }
  },
  components: {
    layVideo2
  },
  created(){
    this.chenglogin();
    this.getData();

    if(window.innerWidth){
      var h = window.innerWidth;
      if(h>640){
        h = 640
      }
      this.video_height =(h-30)/1.777;
    }
    document.title = ' “学习党的二十大·同心跟党走”省直机关无党派人士研修班。';

    var u = navigator.userAgent;

    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if(isIOS){
      this.showfullscreen = false
    }

  },
  mounted() {



  },
  methods:{
    videoplayEnd(){
      this.played = true;
      request.get_integral({
        token:this.token,
        id:this.$route.params.id
      },(res)=>{
        if(res && res.data && res.data.integral>0){
          alert("学习完成,获得"+res.data.integral+'积分')
        }

      })

    },
    getData(){
      request.jifenvideoContent({
        id:this.$route.params.id,
        token:this.token
      },(res)=>{
        if(res && res.code ===200){
          this.videodata = res.data;
          this.played = res.data.played;
          this.$forceUpdate()
        }else if(res.code === 530){
          this.$router.push({name: "login"})
        }else if(res && res.message){
          alert(res.message)
        }
      })
    },
    back(){
      this.$router.push({name:"videojifenlist"})
    },
    chenglogin(){
      let UserData = localStorage.getItem("setUserData");
      if(!UserData){
        this.$router.push({name: "login"})
      }
      try{
        UserData = JSON.parse(UserData);
        if(!UserData.pc_token){
          this.$router.push({name: "login"})
        }else{
          this.token = UserData.pc_token
        }
      }catch (e) {
        this.$router.push({name: "login"})
      }
    },
  }
}
</script>
